import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CoursesSectionContainer = styled(Box)`
  margin-bottom: 48px;
  padding: 0px 24px;
  max-width: 1136px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-bottom: 68px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin-bottom: 95px;
  }
`;

export const CourseList = styled(Box)`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: 32px 0;
  }
`;

export const Title = styled(Typography)`
  text-align: center;
  font-size: 24px;
  line-height: 24px;
  font-weight: 500;
  margin-top: 40px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 30px;
    line-height: 34px;
    margin-top: 48px;
    font-weight: 700;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 36px;
    line-height: 43px;
  }
`;
